import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LogClass, Logger } from "src/app/logger";

@Component({
    selector: "common-switch-form-field",
    templateUrl: "./common-switch-form-field.component.html",
    styleUrls: [],
    standalone: false
})
@LogClass()
export class CommonSwitchFormFieldComponent {
  private logger: Logger;

  @Input() public form: FormGroup;
}
